import { useImperativeHandle, forwardRef } from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';

import { ContentLoader } from 'pages/ContentLibrary/components/ContentLoader/ContentLoader';
import { PublishSection } from 'pages/Proposal/components/Publish/components/PublishContent/components';
import helpers from 'helpers';

import './Sections.scss';

const Sections = forwardRef(
  (
    {
      dragStart,
      dragEnd,
      addNewSectionFromLibrary,
      refetchSections,
      isLoadingMoreSections,
      sections,
      processFetchedData,
    },
    ref
  ) => {
    /**
     * Use imperative handle
     */
    useImperativeHandle(ref, () => ({
      async reloadItems() {
        const { data } = await refetchSections();
        processFetchedData(data, true);
      },
    }));

    return (
      <Row className="library-sections-container">
        {sections?.length > 0 &&
          sections?.map((item, itemIndex) => (
            <Col
              span={24}
              draggable
              onDragStart={(event) => dragStart(event, item)}
              onDragEnd={dragEnd}
              className="toolbar-library-section"
              id={`toolbar-library-section-${item._id}`}
              data-section={JSON.stringify(item)}
              key={itemIndex + item._id}
              onClick={() => addNewSectionFromLibrary({ section: item })}>
              {item.thumbnail ? (
                <div className="section-text">
                  <div className="overlay-mask" />
                  <img
                    src={helpers.formatS3Link(item?.thumbnail)}
                    className="section-image"
                    alt="..."
                  />
                </div>
              ) : (
                <div className="section-text" style={{ flexDirection: 'column' }}>
                  <PublishSection
                    prop={{ draft: { item } }}
                    name="item"
                    configText={(x) => x}
                    ispdf={false}
                  />
                </div>
              )}
              <Row className="section-title">
                <span>{item.libraryTitle}</span>
              </Row>
            </Col>
          ))}

        {isLoadingMoreSections && <ContentLoader />}
      </Row>
    );
  }
);

Sections.propTypes = {
  refetchSections: PropTypes.func.isRequired,
  isLoadingMoreSections: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
  saveProposal: PropTypes.func.isRequired,
  dragStart: PropTypes.func.isRequired,
  dragEnd: PropTypes.func.isRequired,
  addNewSectionFromLibrary: PropTypes.func.isRequired,
  processFetchedData: PropTypes.func.isRequired,
};

export default Sections;
